import { faAnglesDown, faAnglesRight, faAnglesUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"


export default function TendinaArrow({contenuto , title ,classi='', stato=false ,setStato}) {
    console.log(stato , ' stato');
    
    return(
        <div className="col-12" >
            <div style={{border : '3px double #888'}} className={"border-start-0 border-end-0 border-bottom-0 "+classi}>
                <div className="d-flex align-items-baseline" >
                    {!!stato ? 
                        <button className="btn fw-bold fs-3 ms-0 ps-0" onClick={()=>setStato(false)} >
                            <FontAwesomeIcon icon={faAnglesDown} />
                        </button>
                    :
                    <button className="btn fw-bold fs-3 ms-0 ps-0" onClick={()=>setStato(true)} >
                        <FontAwesomeIcon className=" ms-0 ps-0" icon={faAnglesRight} />
                    </button>
                    }
                    <h2>
                        {title}
                    </h2>
                </div>
            </div>
            {stato ? contenuto : ''}
            <div style={{border : '3px double #888'}} className={"border-start-0 border-end-0 border-bottom-0 "+classi}>
            &nbsp;
            </div>
        </div>
    )
}